{
  "category": {
    "category": "Kategorie",
    "createdNewCategory": "neue Kategorie erstellen",
    "description": "Beschreibung",
    "shortDescription": "Kurze Beschreibung",
    "name": "Name",
    "manageCategories": "Kategorien verwalten",
    "deleteCategory": "Kategorie löschen",
    "createAnother": "Erstellen Sie eine weitere Kategorie",
    "deleteAlert": "Sind Sie sicher, dass Sie diese Kategorie löschen möchten?",
    "deleteMoveTarget": "Wählen Sie eine Kategorie aus, in die Sie die Fragen verschieben möchten",
    "noCategory": "Keine Kategorie",
    "updatedCategory": "Kategorie aktualisiert",
    "deletedCategory": "Kategorie gelöscht",
    "addCategory": "Kategorie hinzufügen",
    "editCategory": "Kategorie bearbeiten",
    "searchCategories": "Kategorien suchen",
    "frequency": "Häufigkeit",
    "reassignTo": "Neu zuweisen an",
    "reassignAllAtOnce": "Alle Prozesse auf einmal neu zuweisen",
    "reassignOneByOne": "Einzeln neu zuweisen",
    "confirms": {
      "deleteTitle": "{name} löschen?",
      "deleteTextImmediate": "Diese Kategorie enthält keine Prozesse und kann sofort gelöscht werden. Dies kann nicht widerrufen werden.",
      "chooseReassignMode": "Diese Kategorie enthält noch Prozesse. Wählen Sie aus, wie diese vor dem Löschen neu zugewiesen werden sollen.",
      "deleteTextAllAtOnce": "Wählen Sie eine Kategorie aus, in die alle Prozesse verschoben werden sollen. Dies kann nicht widerrufen werden.",
      "deleteTextOneByOne": "Überprüfen Sie die unten aufgeführten Prozesse und wählen Sie dann eine Kategorie aus, in die sie alle verschoben werden sollen.",
      "affectedProcedures": "Prozesse, die verschoben werden",
      "stillHasProcedures": "Dieser Kategorie sind noch Prozesse zugeordnet. Bitte wählen Sie eine Zielkategorie aus."
    }
  },
  "datatable": {
    "rowsPerPage": "Reihen pro Seite"
  },
  "department": {
    "addDepartment": "Abteilung hinzufügen",
    "confirms": {
      "deleteText": "Alle Benutzer, Verfahren, Lernobjekte, Studien und Geräte in dieser Abteilung werden der unten ausgewählten Abteilung zugewiesen. Dies kann nicht rückgängig gemacht werden.",
      "deleteTitle": "{name} löschen?",
      "restoreText": "Dadurch wird die Abteilung wieder sichtbar und der Zugriff für ihr Personal wiederhergestellt.",
      "restoreTitle": "{name} wiederherstellen?"
    },
    "createNewDepartment": "Neue Abteilung erstellen",
    "deletedDepartment": "Abteilung gelöscht",
    "deleteDepartment": "Abteilung löschen",
    "departmentAdmin": "Admin der Abteilun",
    "departmentName": "Name der Abteilung",
    "edit": "bearbeiten",
    "institution": "Einrichtung",
    "institutionName": "Name der Einrichtung",
    "noReassignmentTarget": "Dies ist die einzige Abteilung in der Einrichtung. Erstellen Sie eine weitere Abteilung, bevor Sie diese löschen.",
    "reassignTo": "Zu Abteilung verschieben",
    "restore": "Wiederherstellen",
    "restoredDepartment": "Abteilung wiederhergestellt",
    "searchDepartments": "Abteilung(en) suchen",
    "showArchived": "Archivierte Abteilungen anzeigen",
    "thisFieldIsRequired": "Dieses Feld ist notwendig"
  },
  "form": {
    "canNotEndBeforeParentStarts": "Kann nicht beenden, bevor Eltern starten",
    "canNotEndBeforeStart": "Kann nicht vor dem Start enden",
    "canNotEndWhenParentEnded": "Kann nicht enden wenn Eltern beenden",
    "canNotStartAfterEnd": "Cann nicht nach dem Ende sarten",
    "canNotStartBeforeParentStarts": "Kann nicht starten, bevor Eltern starten",
    "canNotStartWhenParentEnded": "Kann nicht starten, wenn Eltern beenden",
    "thisFieldIsRequired": "Dieses Feld wird benötigt"
  },
  "general": {
    "accessDenied": "Zugriff verweigert",
    "add": "hinzufügen",
    "back": "zurück",
    "cancel": "abbrechen",
    "close": "schließen",
    "dateAdded": "hinzugefügtes Datum",
    "dateUpdated": "Datum aktualisiert",
    "delete": "Löschen",
    "edit": "bearbeiten",
    "endDate": "Enddatum",
    "loading": "Läd ...",
    "name": "Name",
    "no": "Nein",
    "noData": "keine Daten",
    "ok": "Ok",
    "remove": "entfernen",
    "save": "speichern",
    "selectAll": "alles auswählen",
    "startDate": "Startdatum",
    "yes": "Ja",
    "categories": "Kategorien",
    "manage": "Verwalten",
    "saved": "Gespeichert",
    "updated": "Aktualisiert",
    "deleted": "Gelöscht",
    "selectGender": "Geschlecht auswählen",
    "gender": {
      "male": "Männlich",
      "female": "Weiblich"
    },
    "action": "Aktion",
    "created": "Erstellt",
    "enabled": "Aktiviert",
    "noHistory": "Kein Verlauf vorhanden"
  },
  "institution": {
    "accessRevoked": "Ihre Einrichtung wurde entfernt. Sie wurden abgemeldet.",
    "confirms": {
      "deleteText": "Dadurch werden die Einrichtung und ihre Abteilungen aus dem Admin-Bereich ausgeblendet und der Zugriff für das gesamte Personal sofort entzogen. Dies kann durch Wiederherstellen der Einrichtung rückgängig gemacht werden.",
      "deleteTitle": "{name} löschen?",
      "restoreText": "Dadurch werden die Einrichtung und ihre Abteilungen wieder sichtbar und der Zugriff für ihr Personal wird wiederhergestellt.",
      "restoreTitle": "{name} wiederherstellen?"
    },
    "contact": "Kontakt",
    "createNewInstitution": "Neue Einrichtung erstellen",
    "deletedInstitution": "Einrichtung gelöscht",
    "deleteInstitution": "Einrichtung löschen",
    "name": "Name",
    "region": "Region",
    "restore": "Wiederherstellen",
    "restoredInstitution": "Einrichtung wiederhergestellt",
    "searchInstitutions": "Einrichtung(en) auswählen",
    "showArchived": "Archivierte Einrichtungen anzeigen",
    "switch": "wechseln",
    "switchedTo": "Einrichtung wechseln zu ",
    "unableToSwitch": "wechseln nicht möglich"
  },
  "menu": {
    "categories": "Kategorien",
    "departments": "Abteilung",
    "home": "Startseite",
    "institutions": "Einrichtungen",
    "procedure": "Prozess",
    "procedures": "Prozesse",
    "manageProcedures": "Prozeduren verwalten",
    "manageCategories": "Kategorien verwalten",
    "reinviteusers": "erneut eingeladene Anwender",
    "scheduling": "Terminierung",
    "study": "Studie",
    "survey": "Umfrage",
    "users": "Anwender"
  },
  "device": {
    "udi": "UDI"
  },
  "procedure": {
    "addNewCategory": "neue Kategorie hinzufügen",
    "allSteps": "alle Schritte",
    "authors": "Autor",
    "category": "Kategorie",
    "createNewStep": "neuen Schritt erstellen",
    "defineFeedback": "Feedback geben",
    "department": "Abteilung",
    "description": "Beschreibungen",
    "disableProcedure": "deaktivierter Prozess",
    "addProceduresInformation": "Prozessinformationen hinzufügen",
    "editProceduresInformation": "Prozessinformationen bearbeiten",
    "duplicateStartEndStepWarning": "Es ist nur 1 Start- und 1 Endschritt erlaubt",
    "information": "Informationen",
    "institution": "Einrichtung",
    "language": "Sprache",
    "languagesAvailable": "verfügbare Sprachen",
    "media": "Medien",
    "name": "Name",
    "owner": "Besitzer",
    "procedureCategory": "Prozesskategorie",
    "procedureLanguage": "Sprache des Prozesses",
    "procedureName": "Name des Prozesses",
    "procedureNotFound": "Prozess nicht gefunden",
    "public": "öffentlich",
    "publicPrivate": "öffentlich/privat",
    "revisionHistory": "Änderungsverlauf",
    "searchSteps": "Schritt(e) durchsuchen",
    "seeFeedback": "Feedback ansehen",
    "statistics": "Statistiken",
    "step": "Schritt",
    "unableToLoad": "Prozess kann nicht geladen werden",
    "viewAs": "Ansicht als",
    "checklist": "Checkliste",
    "status": "Status",
    "revisionDate": "Datum",
    "revisionUser": "Benutzer",
    "revisionChanges": "Änderungen",
    "revisionStepAdded": "hinzugefügt",
    "revisionStepRemoved": "entfernt",
    "revisionStepUpdated": "aktualisiert",
    "revisionStepReordered": "neu sortiert"
  },
  "procedures": {
    "addProcedure": "Prozess hinzufügen",
    "category": "Kategorie",
    "deleteProcedure": "Prozess löschen",
    "department": "Abteilung",
    "filter": "filtern",
    "private": "privat",
    "procedures": "Prozesse",
    "public": "öffentlich",
    "publicPrivate": "öffentlich/privat",
    "searchProcedures": "Prozesse durchsuchen",
    "sort": "sortieren"
  },
  "question": {
    "added": "Neue Frage erstellen",
    "answers": "Antworten",
    "cognitionName": "Bezeichnung der Wahrnehmung",
    "cognitionType": "Typ der Wahrnehmung",
    "details": "Details",
    "meaning": "Bedeutung",
    "name": "Name",
    "options": "Optionen",
    "position": "Position",
    "question": "Frage",
    "questionType": "Fragentyp",
    "set": "einstellen",
    "type": "Typ",
    "category": "Kategorie",
    "types": {
      "CHOICE": "Auswahl",
      "COGNITION": "Wahrnehmung",
      "SCALE": "Skala"
    },
    "value": "Wert",
    "editQuestion": "Frage bearbeiten",
    "deleteQuestion": "Frage löschen"
  },
  "step": {
    "addDescription": "Beschreibung hinzufügen",
    "addParentStep": "übergeordneten Schritt hinzufügen",
    "chooseParentSep": "übergeordneten Schritt auswählen",
    "chooseStepOption": "Schrittoptionen auswählen",
    "chooseTransitionType": "Typ der Überleitung auswählen",
    "chooseType": "Typ auswählen",
    "description": "Beschreibung",
    "dropFilesOrClickToUpload": "Datei ablegen oder klicken, um sie hochzuladen",
    "editStep": "Schritt bearbeiten",
    "insertMaxValue": "Maximalwert einfügen",
    "insertMinValue": "Minimalwert einfügen",
    "insertOption": "Option einfügen",
    "option": "Option",
    "owner": "Besitzer",
    "parentStep": "übergeordneter Schritt",
    "previousStep": "vorheriger Schritt",
    "saveMedia": "Medien sichern",
    "stepMedia": "Schritt Medien",
    "transitionToNextStep": "Übergang zum nächsten Schritt",
    "transitionType": "Typ der Überleitung",
    "type": "Typ",
    "value": "Wert",
    "viewInProcedure": "Prozess ansehen",
    "error": {
      "WONT_REACH_END": "Kein Pfad zum ENDE",
      "EXIT_NOT_IN_USE": "Unbenutzter Ausgang",
      "NO_PARENT_SET": "Hat keinen vorherigen Schritt",
      "PARENT_NOT_EXITS": "Definierter übergeordneter Schritt existiert nicht",
      "DUPLICATE_START": "Eine Prozedur kann nur einen START-Schritt haben",
      "DUPLICATE_END": "Eine Prozedur kann nur einen ENDE-Schritt haben",
      "NO_START": "Die Prozedur hat keinen START-Schritt",
      "NO_END": "Die Prozedur hat keinen ENDE-Schritt",
      "MULTIPLE_CHILDREN_FOR_EXIT": "Der Ausgang wird von mehr als einem Schritt verwendet"
    }
  },
  "study": {
    "addStudy": "Neue Studie erstellen",
    "author": "Autor",
    "createdNewStudy": "Neue Studie erstellen",
    "department": "Abteilung",
    "description": "Beschreibung",
    "duration": "Dauer",
    "endDate": "Enddatum",
    "name": "Name",
    "owner": "Besitzer",
    "permission": {
      "department": "Abteilung",
      "institution": "Einrichtung"
    },
    "searchStudy": "Studie suchen",
    "startDate": "Startdatum",
    "status": "Status",
    "studyName": "Name der Studie",
    "visibility": "Ansicht"
  },
  "survey": {
    "addAssessmentPeriod": "Neuen Teilzeitraum erstellen",
    "added": "Neue Studie erstellen",
    "addNew": "Neues hinzufügen",
    "addPeriod": "Neuen Zeitraum hinzufügen",
    "addSurveyPeriod": "Neue Studienzeit erstellen",
    "allAssessmentPeriods": "Alle Bewertungszeiträume",
    "ASSESSMENT_PERIOD": "BEWERTUNGSZEITRAUM",
    "author": "Autor",
    "completePreviousPeriods": "Muss der Studienteilnehmer eine vorherige Phase absolvieren, um diese Phase zu erreichen?",
    "createNewPeriod": "Neuen Zeitraum erstellen",
    "createNewQuestion": "Frage hinzufügen",
    "createNewSurvey": "Neue Studie erstellen",
    "duration": "Dauer",
    "endDate": "Enddatum",
    "key": "Schlüssel",
    "name": "Name",
    "NONE": "KEINE",
    "period": "Zeitraum",
    "periodName": "Name",
    "position": "Position",
    "question": "Frage",
    "questionList": "Fragen",
    "startDate": "Startdatum",
    "SURVEY_PERIOD": "STUDIENZEITRAUM",
    "type": "Typ",
    "surveyHasOverallScore": "Gibt es für die Umfrage eine Gesamtbewertung?",
    "howScoreCalculated": "Wie wird die Gesamtpunktzahl berechnet?",
    "surveyHasCategoryScore": "Gibt es für die Umfrage eine kategoriespezifische Bewertung?",
    "sumAnswers": "Summe aller Antworten",
    "avgAnswers": "Durchschnitt aller Antworten",
    "basicInformation": "Grundlegende Informationen",
    "surveyScore": "Umfrage-Punktzahl",
    "selectOption": "Option auswählen",
    "selectSurvey": "Umfrage auswählen",
    "jobEngagement": "Arbeitsengagement",
    "burnoutScores": "Burnout-Punktzahl",
    "viewScores": "Punktzahl ansehen",
    "hasOverallScore": "Die Umfrage hat eine Gesamtpunktzahl",
    "hasNoOverallScore": "Die Umfrage hat keine Gesamtpunktzahl",
    "noChartData": "Keine Daten für die ausgewählte Umfrage verfügbar",
    "selectChartType": "Diagrammtyp auswählen",
    "surveyCategoryInfo": "Die Umfrage verfügt über Kategorien zum Organisieren von Fragen. In diesem Abschnitt haben Sie die Möglichkeit, sie zu ändern und zu überwachen."
  },
  "user": {
    "accountSettings": "Kontoeinstellungen",
    "chooseUserRole": "Benutzerrolle auswählen",
    "contact": "Kontakt",
    "contactInformation": "Kontaktinformationen",
    "dateOfBirth": "Geburtsdatum",
    "department": "Abteilung",
    "emails": "E-Mails",
    "emailsDescription": "Fügen Sie eine oder mehrere E-Mails, getrennt durch einen Strichpunkt (Semicolon)ein. Einladungen zur Registrierung werden per Mail an die Benutzer versendet.",
    "filter": "Filter",
    "gender": "Geschlecht",
    "institution": "Einrichtung",
    "institutionalAdmin": "Admin der Einrichtung",
    "institutionAndDepartment": "Einrichtung und Abteilung ",
    "inviteUsers": "Benutzer einladen",
    "logOut": "Log-out",
    "nurse": "Krankenpfleger/in",
    "password": "Passwort",
    "patient": "Patient",
    "reInviteUsers": "Benutzer erneut einladen",
    "resetPassword": "Passwort zurücksetzen",
    "resetRequestSentTo": "Anfrage zum Zurücksetzen gesendet an",
    "searchUsers": "Benutzer suchen",
    "sendResetPasswordEmailTo": "E-mail zum zurücksetzen des Passwortes senden an",
    "sort": "sortieren",
    "subscription": "Abonnement",
    "thisFieldIsRequired": "Dieses Feld wird benötigt",
    "user": "Benutzer",
    "userDetailsUpdated": "Aktualisierung der Benutzerdetails",
    "userInformation": "Benutzerinformationen",
    "userRole": "Benutzerrolle"
  },
  "approvalRequest": {
    "actionType": "Action Type",
    "requestedBy": "Requested By",
    "approvedBy": "Approved By",
    "confirms": {
      "approveTitle": "Approve request",
      "approveText": "Are you sure you want to approve this request?",
      "rejectTitle": "Reject request",
      "rejectText": "Please provide a reason for rejecting this request.",
      "rejectReasonPlaceholder": "Rejection reason"
    },
    "actionTypes": {
      "PERMISSION_GRANT": "Permission Grant",
      "PERMISSION_REVOKE": "Permission Revoke",
      "EXPORT_VISITS": "Export Visits",
      "EXPORT_LOCATION_HISTORY": "Export Location History",
      "EXPORT_ARRIVAL_HISTORY": "Export Arrival History",
      "ENABLE_USER": "Enable User",
      "DISABLE_USER": "Disable User"
    },
    "toasts": {
      "created": "Approval request created",
      "applied": "Action applied",
      "applyFailed": "Failed to apply action",
      "approved": "Request approved",
      "approveFailed": "Failed to approve request",
      "rejected": "Request rejected",
      "rejectFailed": "Failed to reject request"
    }
  },
  "patients": {
    "standingAssignment": "Feste Zuweisung",
    "noStandingAssignment": "Keine feste Zuweisung",
    "unknownNurse": "Zugewiesene Pflegekraft (Name nicht verfügbar)",
    "standingAssignmentHelperText": "Nur Benutzer mit der Rolle „Home Nurse“ können als feste Zuweisung festgelegt werden.",
    "changeStandingAssignment": "Zuweisung ändern",
    "clearStandingAssignment": "Zuweisung entfernen",
    "confirmClearStandingAssignmentText": "Möchten Sie die feste Zuweisung für diesen Patienten wirklich entfernen?",
    "standingAssignmentLabel": "{name} (fest zugewiesen)",
    "onShiftLabel": "{name} (im Dienst)",
    "currentlyOnShiftWith": "Derzeit im Dienst mit",
    "notCurrentlyOnShift": "Derzeit nicht im Dienst",
    "visitName": "Name",
    "visitDate": "Datum",
    "performedBy": "Durchgeführt von",
    "status": "Status",
    "location": "Standort / Zimmer (optional)",
    "enterLocation": "Standort oder Zimmer eingeben",
    "admissionDate": "Aufnahmedatum (optional)",
    "dischargeDate": "Entlassungsdatum (optional)",
    "acuity": "Schweregrad (optional)",
    "unsupportedFieldsNotice": "Allergie, Medikation, Größe, Gewicht, Patiententyp sowie Zustandscode/-name werden von diesem Import nicht unterstützt – bitte nach dem Import manuell hinzufügen.",
    "import": {
      "importSucceeded": "{created} Patient(en) importiert, {duplicates} Duplikat(e) übersprungen.",
      "departmentsLoadFailed": "Abteilungen konnten nicht geladen werden. Bitte versuchen Sie es erneut."
    }
  },
  "errors": {
    "UNKNOWN_ERROR": "Unbekannter Fehler"
  },
  "titles": {
    "categories": "Kategorien",
    "visitreport": "Besuchsbericht"
  },
  "toasts": {
    "patientAdded": "Patient erfolgreich hinzugefügt",
    "patientUpdated": "Patient erfolgreich aktualisiert",
    "procedureAdded": "Verfahren erfolgreich hinzugefügt",
    "procedureUpdated": "Verfahren erfolgreich aktualisiert",
    "procedureDeleted": "Verfahren erfolgreich gelöscht",
    "visitAdded": "Besuch erfolgreich hinzugefügt",
    "visitUpdated": "Besuch erfolgreich aktualisiert",
    "visitDeleted": "Besuch erfolgreich gelöscht"
  },
  "studyResults": {
    "user": "Benutzer",
    "department": "Abteilung",
    "study": "Studie",
    "date": "Datum",
    "survey": "Umfrage",
    "results": "Ergebnisse",
    "studyResults": "Studienergebnisse",
    "surveyResults": "Umfrageergebnisse",
    "list": "Liste",
    "graph": "Diagramm",
    "surveyStartDate": "Umfragebeginn",
    "surveyEndDate": "Umfrageende",
    "userResults": "Benutzerergebnisse",
    "question": "Frage",
    "questionType": "Fragetyp",
    "answer": "Antwort",
    "position": "Position",
    "scaleAnswerFormat": "{value} — {meaning}"
  },
  "visitReport": {
    "consent": "Einwilligung",
    "viewConsent": "Einwilligung ansehen",
    "homeVisit": "Hausbesuch",
    "recomendationForTreatment": "Empfehlungen für Behandlung, Pflege, Arbeit und ambulante Betreuung",
    "anamnesis": "Anamnese",
    "answerType": "Antworttyp",
    "contactPhone": "Kontakttelefon",
    "contactEmail": "Kontakt-E-Mail",
    "visitMadeBy": "Besuch durchgeführt von",
    "homeVisitTime": "Zeitpunkt des Hausbesuchs",
    "visitForm": "Besuchsformular",
    "viewHistory": "Verlauf ansehen",
    "patientsPrimaryHealthConcern": "Hauptgesundheitsanliegen des Patienten",
    "conditionAssesmentInformation": "Informationen zur Zustandsbeurteilung",
    "bloodPressure": "Blutdruck",
    "measurement": "Messung",
    "BMI": "BMI",
    "diagnosis": "Diagnose",
    "appliedMedicalTreatments": "Angewandte medikamentöse Behandlung",
    "appliedTreatment": "Angewandte Behandlung",
    "descriptionOfTestsConsultationPlans": "Beschreibung der Untersuchungen/Konsultationspläne",
    "instrumentalTests": "Instrumentelle Untersuchungen",
    "laboratoryTests": "Labortests",
    "appliedMedicalTreatment": "Angewandte medizinische Behandlung",
    "specialist": "Facharzt",
    "status": "Status",
    "complaintData": "Beschwerdedaten",
    "pulse": "Puls",
    "viewFullVisitForm": "Vollständiges Besuchsformular ansehen",
    "height": "Größe",
    "weight": "Gewicht"
  }
}
